export const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line', description: 'Discover the latest sneaker and shoe spreadsheets from trusted CSSBuy sellers' },
  { name: 'Hoodies & Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line', description: 'Cozy hoodies and stylish sweaters from verified sellers with QC photos' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-shirt-line', description: 'Trendy graphic tees and essential t-shirts at unbeatable prices' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-contrast-drop-2-line', description: 'Premium jackets and outerwear from top-rated CSSBuy sellers' },
  { name: 'Pants & Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-pantone-line', description: 'Stylish pants, jeans, and shorts for every season and occasion' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-customer-service-line', description: 'Caps, beanies, and headwear accessories from trusted sources' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line', description: 'Coordinated outfit sets and matching ensembles at great value' },
  { name: 'Underwear & Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-checkbox-blank-line', description: 'Comfortable essentials and basics from reliable sellers' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-basketball-line', description: 'Sports jerseys and athletic wear for fans and collectors' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-glasses-line', description: 'Watches, sunglasses, jewelry, and fashion accessories' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-briefcase-line', description: 'Backpacks, handbags, and travel bags from top sellers' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link', description: 'Designer belts and quality leather accessories at affordable prices' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line', description: 'Luxury fragrances and perfumes from verified CSSBuy vendors' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line', description: 'Everything else — electronics, home goods, and unique finds' },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';

export const faqItems = [
  {
    question: 'What is a CSSBuy Spreadsheet?',
    answer: 'A CSSBuy Spreadsheet is a curated, regularly updated directory of product listings, trusted seller contacts, QC (Quality Check) photos, and pricing information that helps shoppers navigate the vast marketplace efficiently. Our spreadsheets include product codes, direct links, shipping estimates, and seller ratings to make your shopping experience seamless and safe.',
  },
  {
    question: 'How often is the spreadsheet updated?',
    answer: 'Our CSSBuy Spreadsheet directory is updated daily to ensure you always have access to the freshest finds, latest seller reviews, and newest product listings. We continuously verify seller status and remove inactive or unreliable sources to maintain the highest quality database. Each update is timestamped so you know exactly when the information was last refreshed.',
  },
  {
    question: 'Are all sellers in the spreadsheet verified?',
    answer: 'Yes, every seller featured in our spreadsheet undergoes a thorough verification process. We check for consistent positive feedback, reliable shipping history, authentic QC photo availability, and responsive communication. Only sellers who meet our strict criteria are included, giving you peace of mind with every purchase.',
  },
  {
    question: 'Do I need a CSSBuy account to use the spreadsheet?',
    answer: 'While you do need a CSSBuy account to place orders through the platform, you can freely browse our spreadsheet directory to discover products, compare prices, and research sellers before signing up. The spreadsheet serves as your research companion throughout the shopping journey.',
  },
  {
    question: 'What categories are covered in the spreadsheet?',
    answer: 'Our spreadsheet covers 14 major categories including Shoes, Hoodies & Sweaters, T-Shirts, Jackets, Pants & Shorts, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes, and Other Stuff. Each category contains hundreds of verified product listings with direct links and seller information.',
  },
  {
    question: 'Is the CSSBuy Spreadsheet free to access?',
    answer: 'Absolutely! Our CSSBuy Spreadsheet directory is 100% free to access. We believe in making quality shopping resources available to everyone. Simply browse our category pages, find what you love, and click through to start shopping on kaspreadsheet.com.',
  },
  {
    question: 'How do I use the CSSBuy Spreadsheet effectively?',
    answer: 'Start by selecting your desired category from our dropdown menu or category grid. Browse through the listings, compare seller ratings and prices, check available QC photos, and click through to the main site when you are ready to purchase. For the best experience, bookmark our spreadsheet page and check back daily for new additions.',
  },
  {
    question: 'What makes your spreadsheet different from others?',
    answer: 'Unlike generic spreadsheets found on forums, ours is professionally maintained with daily updates, verified seller status, comprehensive QC photo archives, detailed shipping guides, and an intuitive category navigation system. We prioritize accuracy, freshness, and user experience above all else.',
  },
  {
    question: 'Can I request new sellers to be added?',
    answer: 'Yes! We welcome community contributions. If you have discovered a reliable CSSBuy seller who is not yet in our spreadsheet, reach out to us through our contact channels. Our team reviews every submission and adds qualifying sellers after verification. Community-driven curation helps us keep the spreadsheet comprehensive and trustworthy.',
  },
  {
    question: 'Is shopping through CSSBuy safe?',
    answer: 'CSSBuy is one of the most established shopping agents in the market with a proven track record of secure transactions. When combined with our verified seller spreadsheet, you get an extra layer of protection. Always follow our safety guidelines, check QC photos before shipping, and use the platform\'s buyer protection features for the safest experience.',
  },
];

export const trustBadges = [
  { label: 'Updated Daily', icon: 'ri-refresh-line' },
  { label: 'Verified Sellers', icon: 'ri-shield-check-line' },
  { label: 'Safe Shopping', icon: 'ri-lock-line' },
  { label: 'Free Access', icon: 'ri-gift-line' },
  { label: 'Community Recommended', icon: 'ri-team-line' },
];

export const whyChooseItems = [
  {
    title: 'Verified Sellers Only',
    description: 'Every seller in our directory passes rigorous verification. We check feedback scores, shipping reliability, and QC photo quality before listing.',
    icon: 'ri-shield-star-line',
  },
  {
    title: 'Daily Fresh Updates',
    description: 'Our spreadsheet is refreshed every single day. New products, updated prices, and fresh seller reviews are always at your fingertips.',
    icon: 'ri-calendar-check-line',
  },
  {
    title: 'Comprehensive QC Database',
    description: 'Access thousands of QC inspection photos and detailed quality reports so you know exactly what you are getting before shipping.',
    icon: 'ri-image-line',
  },
  {
    title: 'Smart Category Navigation',
    description: 'Browse effortlessly through 14 carefully organized categories. Find exactly what you need with our intuitive filtering system.',
    icon: 'ri-menu-search-line',
  },
  {
    title: 'Trusted by Thousands',
    description: 'Join a growing community of savvy shoppers who rely on our spreadsheet for their CSSBuy purchases every day.',
    icon: 'ri-user-heart-line',
  },
  {
    title: 'Shipping Guide Included',
    description: 'Get detailed shipping cost estimates, delivery timelines, and packaging tips to optimize your international orders.',
    icon: 'ri-ship-line',
  },
];

export const stats = [
  { value: '15,000+', label: 'Verified Products' },
  { value: '500+', label: 'Trusted Sellers' },
  { value: 'Daily', label: 'Updates' },
  { value: '50,000+', label: 'Happy Shoppers' },
];